import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@ublend-npm/react-tooltip';

import { UserChip, CancelIcon } from './UserSelectedChip.styled';
import { User } from '../types';

const UserSelectedChip = ({ onRemoveChip, user, ...props }) => (
  <Tooltip title={user.email} position="top">
    <UserChip
      key
      label={`${user.fullName}`}
      deleteIcon={<CancelIcon />}
      onDelete={onRemoveChip}
      className={
        user.educatorInSpaces.length === 0 ? 'notEducatorWarning' : null
      }
      {...props}
    />
  </Tooltip>
);

UserSelectedChip.propTypes = {
  user: User.isRequired,
  onRemoveChip: PropTypes.func.isRequired,
};

export default UserSelectedChip;
